import type { CategoryMeta } from "@/types/catalog";
import { categoryPath, homePath, searchPath } from "@/lib/routes";

const categories: Record<string, CategoryMeta> = {
  "tech-gaming": {
    slug: "tech-gaming",
    title: "Tech & Gaming",
    description:
      "Shop the latest tech and gaming essentials at everyday low prices.",
    breadcrumbs: [
      { label: "Home", href: homePath() },
      { label: "Tech & Gaming" },
    ],
    relatedCategories: [
      { label: "Headphones", href: categoryPath("tech-gaming") },
      { label: "Tablets", href: categoryPath("tech-gaming") },
    ],
  },
  "mobile-phones": {
    slug: "mobile-phones",
    title: "Mobile Phones",
    description:
      "Discover affordable smartphones and accessories for every budget.",
    breadcrumbs: [
      { label: "Home", href: homePath() },
      { label: "Tech & Gaming", href: categoryPath("tech-gaming") },
      { label: "Mobile Phones" },
    ],
    relatedCategories: [
      { label: "Phone Cases", href: categoryPath("mobile-phones") },
      { label: "Chargers", href: categoryPath("mobile-phones") },
    ],
  },
  optus: {
    slug: "optus",
    title: "Optus",
    description:
      "Shop Optus prepaid smartphones and bundles with great value SIM offers. Get connected with reliable 4G devices and exclusive in-store deals.",
    breadcrumbs: [
      { label: "Home", href: homePath() },
      { label: "Tech & Gaming", href: categoryPath("tech-gaming") },
      { label: "Mobile Phones", href: categoryPath("mobile-phones") },
      { label: "Optus" },
    ],
    relatedCategories: [
      { label: "Samsung", href: categoryPath("mobile-phones", "samsung") },
      { label: "Nokia", href: categoryPath("mobile-phones", "nokia") },
      { label: "Phone Accessories", href: categoryPath("mobile-phones") },
    ],
  },
  "womens-clothing": {
    slug: "womens-clothing",
    title: "Women's Clothing",
    description: "Everyday low prices on women's fashion and essentials.",
    breadcrumbs: [
      { label: "Home", href: homePath() },
      { label: "Women's Clothing" },
    ],
    relatedCategories: [
      { label: "Hoodies", href: searchPath("hoodie") },
      { label: "Pants", href: searchPath("pants") },
    ],
  },
  toys: {
    slug: "toys",
    title: "Toys",
    description: "Fun for the whole family with games, puzzles and more.",
    breadcrumbs: [{ label: "Home", href: homePath() }, { label: "Toys" }],
    relatedCategories: [
      { label: "Card Games", href: categoryPath("toys") },
      { label: "Board Games", href: categoryPath("toys") },
    ],
  },
};

export function getAllCategories(): CategoryMeta[] {
  return Object.values(categories);
}

export function getCategoryMeta(
  categorySlug: string,
  brandSlug?: string,
): CategoryMeta | undefined {
  if (brandSlug) {
    const brandKey = brandSlug.toLowerCase();
    if (categories[brandKey]) return categories[brandKey];
    const parent = categories[categorySlug];
    if (!parent) return undefined;
    return {
      slug: brandSlug,
      title: brandSlug.charAt(0).toUpperCase() + brandSlug.slice(1),
      description: parent.description,
      breadcrumbs: [
        ...parent.breadcrumbs.slice(0, -1),
        {
          label: parent.breadcrumbs[parent.breadcrumbs.length - 1]?.label ?? categorySlug,
          href: categoryPath(categorySlug),
        },
        {
          label: brandSlug.charAt(0).toUpperCase() + brandSlug.slice(1),
        },
      ],
      relatedCategories: parent.relatedCategories,
    };
  }
  return categories[categorySlug];
}
